export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-sidebar-header/index.ts